'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = withComponentMapping;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dlv = require('dlv');

var _dlv2 = _interopRequireDefault(_dlv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function withComponentMapping(ComposedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
        (0, _inherits3.default)(ComponentWithMapping, _Component);

        function ComponentWithMapping() {
            (0, _classCallCheck3.default)(this, ComponentWithMapping);
            return (0, _possibleConstructorReturn3.default)(this, (ComponentWithMapping.__proto__ || (0, _getPrototypeOf2.default)(ComponentWithMapping)).apply(this, arguments));
        }

        (0, _createClass3.default)(ComponentWithMapping, [{
            key: 'getComponentsMapping',

            /* eslint-enable react/forbid-prop-types */

            value: function getComponentsMapping() {
                if (this.props.localComponentsMapping) {
                    return this.props.localComponentsMapping;
                }

                return (0, _dlv2.default)(this.context, 'cms.components.localComponentsMapping', {});
            }
            /* eslint-disable react/forbid-prop-types */

        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, this.props, {
                    localComponentsMapping: this.getComponentsMapping()
                }));
            }
        }]);
        return ComponentWithMapping;
    }(_react.Component), _class.propTypes = {
        localComponentsMapping: _propTypes2.default.object }, _class.defaultProps = {
        localComponentsMapping: {}
    }, _class.contextTypes = {
        cms: _propTypes2.default.object
    }, _temp;
}
//# sourceMappingURL=with-component-mapping.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/component-provider/lib/cjs/with-component-mapping.js
 ** module id = 482
 ** module chunks = 1
 **/